var _rect, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustworksLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 124,
    fill: "none",
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "#fff",
    rx: 62
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 124,
    height: 124,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "#fff",
    rx: 62
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52B0FF",
    d: "M84.197 83.865H40.004v17.672h44.193V83.865Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#050000",
    d: "m40 66.074 14.77-2.832c.413 5.045 2.359 9.706 7.37 9.706 3.892 0 6.664-1.917 6.664-6.343V23h15.39v39.976c0 15.666-6.457 22.098-22.083 22.098-16.185 0-20.873-9.47-22.111-19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustworksLogo);
export default __webpack_public_path__ + "static/media/justworksLogo.1942f58f7f2c89fcc35ae9315d28db36.svg";
export { ForwardRef as ReactComponent };